import React from "react";
import {
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  InputGroup,
  Input,
} from "reactstrap";
import { FaSpinner, FaMoneyBillWave, FaMobileAlt } from "react-icons/fa";
import { useFormik } from "formik";
import { useGetPayments } from "hooks/usePayments";
import { useDispatch } from "react-redux";
import { setPaymentDetails } from "slices/payment/reducer";

import { useSelector } from "hooks/useSelector";

const PaymentForm = ({ setActiveTab, payment_method_id = "" }) => {
  const dispatch = useDispatch();
  const { data: paymentTypes, isLoading } = useGetPayments();
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();

  const totalPrice = useSelector((state) => state.cart.totalPrice);
  //const amountPaid = useSelector((state) => state.cart.totalPrice);
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  const formik = useFormik({
    initialValues: {
      cashAmount: "",
      mobileMoneyNumber: "",
      payment_method_id: payment_method_id,
      status: "draft",
    },
    enableReinitialize: true,

    onSubmit: (values) => {
      const paymentDetails = {
        method: paymentTypes.find(
          (type) => type.id === values.payment_method_id
        )?.name,
        methodId: values.payment_method_id,
        amountPaid: values.cashAmount || totalPrice,
        mobileMoneyNumber: values.mobileMoneyNumber || "",
        status: values.status || "draft",
      };

      dispatch(setPaymentDetails(paymentDetails));

      setActiveTab("3");
    },
  });

  // useEffect(() => {
  //   if (payment_method_id) {
  //     setSelectedPaymentMethod(
  //       paymentTypes.find(
  //         (type) => type.id.toString() === payment_method_id.toString()
  //       )?.name
  //     );
  //   }
  // }, [payment_method_id, paymentTypes]);

  return (
    <Card className="border-0 shadow-none">
      <CardBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <div className="payment-method mb-4">
            <h5 className="text-dark mb-3 border-bottom pb-2">
              Select Payment Method
            </h5>
            {isLoading ? (
              <div className="d-flex justify-content-center">
                <FaSpinner
                  className="spinner"
                  style={{
                    fontSize: "24px",
                    animation: "spin 1s linear infinite",
                  }}
                />
              </div>
            ) : (
              <div>
                <FormGroup className="mb-3">
                  <Label
                    className="fw-medium mb-1"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Payment Method
                  </Label>
                  <div
                    className="d-grid gap-3"
                    style={{
                      gridTemplateColumns: "repeat(2, 1fr)",
                      padding: "10px",
                    }}
                  >
                    {paymentTypes && paymentTypes.length > 0 ? (
                      paymentTypes.map((type) => (
                        <div
                          key={type.id}
                          className={`transfer-type-option ${
                            formik.values.payment_method_id === type.id
                              ? "active"
                              : ""
                          }`}
                          onClick={() => {
                            formik.setFieldValue("payment_method_id", type.id);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            padding: "20px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            minWidth: "150px",
                          }}
                        >
                          <Input
                            type="radio"
                            checked={
                              formik.values.payment_method_id === type.id
                            }
                            onChange={() =>
                              formik.setFieldValue("payment_method_id", type.id)
                            }
                            style={{ marginRight: "10px" }}
                          />
                          {type.name.toLowerCase() === "cash" && (
                            <FaMoneyBillWave
                              className="text-primary"
                              style={{ fontSize: "1.5rem" }}
                            />
                          )}
                          {type.name.toLowerCase() === "mobile money" && (
                            <FaMobileAlt
                              className="text-primary"
                              style={{ fontSize: "1.5rem" }}
                            />
                          )}
                          <span
                            style={{ fontSize: "1rem", marginLeft: "10px" }}
                          >
                            {type.name}
                          </span>
                        </div>
                      ))
                    ) : (
                      <p>No payment methods available.</p>
                    )}
                  </div>

                  <Label for="Amount Paid" className="mt-2 me-2">
                    Amount Paid:
                  </Label>
                  {/* <Input
                    type="number"
                    id=" amountPaid"
                    name="cashAmount"
                    onChange={formik.handleChange}
                    value={formik.values.cashAmount}
                  /> */}
                  <InputGroup>
                    <span
                      className="input-group-text"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {defaultCurrency}
                    </span>
                    <Input
                      type="number"
                      min="0"
                      style={{ fontSize: "0.85rem", height: "38px" }}
                      value={formik.values.cashAmount}
                      onChange={(e) =>
                        formik.setFieldValue("cashAmount", e.target.value)
                      }
                      invalid={
                        formik.touched.cashAmount && !!formik.errors.cashAmount
                      }
                    />
                  </InputGroup>
                </FormGroup>

                <div className="d-flex justify-content-between mt-4">
                  <Button color="dark" onClick={() => setActiveTab("1")}>
                    Back
                  </Button>

                  <Button
                    color="primary"
                    type="submit"
                    disabled={!formik.values.payment_method_id}
                  >
                    Next
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

export default PaymentForm;
